import { referentialApiConnector } from 'apiConnector/secondary-market/referentialApiConnector';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, filter, map, mergeMap, takeUntil, withLatestFrom } from 'rxjs/operators';
import { cpOrderKycActions } from 'state/secondaryMarket/cpOrder/referential/kyc/kyc.actions';
import type { EpicWithThunk } from 'state/state.common';

import { getTabRemoved$ } from '../utils';

export function fetchKycStatusEpic(): EpicWithThunk {
  return (actions$, state$, { httpClient, selectors: { isFeatureEnabled } }) => {
    const { getKycStatus } = referentialApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_CP_ORDER_KYC_STATUS_REQUESTED'),
      withLatestFrom(state$),
      filter(([, state]) => !isFeatureEnabled(state, 'HideKYCDisplayParis')),
      mergeMap(([{ tabId, clientBdrId, salesCountry }]) => {
        return getKycStatus(clientBdrId, salesCountry).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          map(data => cpOrderKycActions.secondaryMarketKycStatusReceived(tabId, data)),
          catchError((_: Error) => {
            return of(cpOrderKycActions.secondaryMarketKycStatusFailed(tabId));
          }),
        );
      }),
    );
  };
}
